import type { ListerVerdict } from "../../../lib/api";

const STYLE = { green: "border-green-700/60 bg-green-900/20 text-green-200", yellow: "border-yellow-700/60 bg-yellow-900/20 text-yellow-200", red: "border-red-700/60 bg-red-900/20 text-red-200" };

export default function VerdictBanner({ verdict, confirmed, onConfirm }: { verdict: ListerVerdict; confirmed: boolean; onConfirm: () => void }) {
  return (
    <div className={`border rounded-md p-3 font-mono text-sm ${STYLE[verdict.level]}`} role="status">
      <div className="font-semibold">{verdict.headline}</div>
      {/* A verdict with many points (routine for a red one) can run taller than a phone
          screen — capped and scrollable below md so it can never push everything under it,
          including a raw card's own condition control right below this banner, off the
          initial fold (the same reachability the sticky action bar gets by being fixed).
          Every point is still there and still fully readable; it just scrolls in its own box
          instead of the whole page. Desktop is untouched — it has the vertical room. */}
      {verdict.points.length > 0 && <ul className="mt-1 list-disc pl-5 space-y-0.5 text-xs opacity-90 max-h-40 overflow-y-auto md:max-h-none md:overflow-visible">{verdict.points.map((p, i) => <li key={i}>{p}</li>)}</ul>}
      {verdict.level === "red" && (
        <button onClick={onConfirm} disabled={confirmed} className="mt-2 bg-zinc-800 hover:bg-zinc-700 disabled:opacity-60 px-3 py-2 rounded text-zinc-100">
          {confirmed ? "Confirmed — you checked this" : "I checked this, continue"}
        </button>
      )}
    </div>
  );
}
